import { render } from "./CollectorTrends.vue?vue&type=template&id=7076e95c&scoped=true"
import script from "./CollectorTrends.vue?vue&type=script&lang=js"
export * from "./CollectorTrends.vue?vue&type=script&lang=js"

import "./CollectorTrends.vue?vue&type=style&index=0&id=7076e95c&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7076e95c"]])

export default __exports__